/* eslint-disable react/button-has-type */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/require-default-props */
import React, { FC, ReactNode, MouseEventHandler } from "react";
import clsx from "clsx";

type propsType = {
  type?: "button" | "submit" | "reset" | undefined;
  border?: boolean;
  className?: string;
  children: ReactNode;
  disabled?: boolean;
  role?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export const Button: FC<propsType> = (props) => {
  const classes = clsx("button", props.className, {
    button_border: props.border,
  });

  return (
    <button
      className={classes}
      disabled={props.disabled}
      type={props.type}
      role={props.role}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
};

Button.defaultProps = {
  type: "button",
};
